import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    .gerry-layout {
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];
      max-width: 100%;
    }

    .text-right.text-big-panel,
    .text-left.text-big-panel,
    .text-right.text-small-panel,
    .text-left.text-small-panel {
      grid-column: 2 / 8;
      grid-row: 2;
    }

    .image-left.image-small-panel,
    .image-right.image-small-panel,
    .image-left.image-big-panel,
    .image-right.image-big-panel {
      grid-column: 2 / 8;
      grid-row: 3;
    }

    /* Statement text: an h3 tag on the H2 role (18/22 -> 28/40 at 600px). */
    h3 {
      font-size: var(--fs-headline);
      line-height: var(--lh-headline);
      letter-spacing: var(--ls-headline);
      font-weight: var(--fw-regular);
    }

    .text-wrapper {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    .text-wrapper > .text {
      padding: calc(20rem / var(--default-rem-px-count));
      text-wrap: balance;
    }

    .image-wrapper {
      height: 100%;
      display: flex;
      justify-content: center;
    }

    .image-wrapper img {
      max-width: 100%;
      object-fit: cover;
      object-position: center;
    }

    @media (min-width: 600px) {
      .gerry-layout {
        grid-template-rows:
          var(--block-top-padding)
          minmax(0, auto)
          var(--block-bottom-padding)
          [last-line];
      }

      .image-left.image-small-panel,
      .text-left.text-small-panel {
        grid-column: 2 / 6;
        grid-row: 2;
      }

      .image-right.image-small-panel,
      .text-right.text-small-panel {
        grid-column: 10 / 14;
        grid-row: 2;
      }

      .image-left.image-big-panel,
      .text-left.text-big-panel {
        grid-column: 2 / 10;
        grid-row: 2;
      }

      .image-right.image-big-panel,
      .text-right.text-big-panel {
        grid-column: 6 / 14;
        grid-row: 2;
      }
    }
  `,
];
